export default __webpack_public_path__ + "img/cAxtrkKs.8250edc7.svg";